export const TENANT = process.env.REACT_APP_TENANT ? process.env.REACT_APP_TENANT : (window.location.pathname.split('/')[1] !== "app" ? window.location.pathname.split('/')[1] : "") 
export const API_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 
`http://127.0.0.1:8000/${TENANT}/api` : 
(process.env.REACT_APP_API_URL ? 
  `${process.env.REACT_APP_API_URL}/${TENANT}/api` : 
  `${window.location.origin}/${TENANT}/api`);
  export const API_BASE_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 
`http://127.0.0.1:8000/${TENANT}` : 
(process.env.REACT_APP_API_URL ? 
  `${process.env.REACT_APP_API_URL}/${TENANT}` : 
  `${window.location.origin}/${TENANT}`);
export const WS_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 
`http://127.0.0.1:8001/${TENANT}/websocket` : 
(process.env.REACT_APP_API_URL ? 
  `${process.env.REACT_APP_API_URL}/${TENANT}/websocket` : 
  `${window.location.origin}/${TENANT}/websocket`);
// builds with a fixed tenant (native app, unisr web app) are served without the /{tenant} path segment
export const WEB_PATH = process.env.REACT_APP_TENANT ? '' : `/${TENANT}`
// the backend redirects (SAML callback, error page) still use /{tenant}/...: drop it before the router reads the url
if (process.env.REACT_APP_TENANT && window.location.pathname.startsWith(`/${TENANT}/`)) {
  const { pathname, search, hash } = window.location
  window.history.replaceState(null, '', pathname.slice(TENANT.length + 1) + search + hash)
}
export const BASE_URL = `${window.location.origin}${WEB_PATH}/`
export const HTTP_TIMEOUT = 10000;
export const DEFAULT_FIELDS = ['firstname', 'lastname', 'nickname']
export const DEVICE = {
  mobile: `(min-width: 320px)`,
  tablet: `(min-width: 768px)`,
  laptop: `(min-width: 1024px)`,
  laptopL: `(min-width: 1440px)`,
  desktop: `(min-width: 2560px)`,
};
export const OFA_TENANT = ['ofa-sapienza']
export const IN_APP_TENANT = ['logica-scuole', 'orientamento-iulm', 'orientamento-constructor', 'orientamento-ehl']
// tenants that show the ofa recovery status even when they are not flagged as ofa
export const OFA_RECOVERY_TENANT = ['unisr']
// tenants whose main login is SAML
export const SAML_LOGIN_TENANT = ['unisr']